import { useState } from 'react';
import callbacksService from '../../services/callbacks.service';
import { colors } from '../../styles/theme';

/** Raise the callback request; the answer is only whether it reached the Account Executive. */
export async function sendCallRequest(
  productId: string | null | undefined,
  context: string,
): Promise<'sent' | 'failed'> {
  try {
    await callbacksService.requestCallback({
      ...(productId ? { product_id: productId } : {}),
      context_note: context,
    });
    return 'sent';
  } catch {
    return 'failed';
  }
}

/**
 * The one "Request a call" action a client meets wherever the portal sends them to
 * their Account Executive. It raises a callback request (the agent gets it in their
 * queue and calls back at their next free slot); nothing is scheduled.
 */
export default function RequestCallButton({
  productId,
  context,
}: Readonly<{
  /** The Series the call is about, when there is one. */
  productId?: string | null;
  /** A short note for the Account Executive: where the client was and why. */
  context: string;
}>): JSX.Element {
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'failed'>('idle');

  async function requestCall(): Promise<void> {
    setState('sending');
    setState(await sendCallRequest(productId, context));
  }

  if (state === 'sent') {
    return <p className="mt-2 text-sm font-semibold">Done — your Account Executive will contact you.</p>;
  }
  return (
    <>
      <button
        type="button"
        onClick={() => { void requestCall(); }}
        disabled={state === 'sending'}
        className="mt-2 px-3 py-1.5 rounded-lg text-sm font-semibold"
        style={{ background: colors.ink, color: colors.surface }}
      >
        {state === 'sending' ? 'Requesting…' : 'Request a call'}
      </button>
      {state === 'failed' && (
        <p className="mt-2 text-sm">We could not send your request. Please try again.</p>
      )}
    </>
  );
}
